module.exports = __webpack_public_path__ + "img/f12.9ae50437.jpg";